export default __webpack_public_path__ + "static/media/icon-lightning-circle.e231b8dd.svg";